import React from "react";
import { useNavigate } from "react-router-dom";

import { AssessmentListTableProps, IColumnProps } from "../../../interfaces/tables";
import { EmployerField } from "../../../interfaces/employer";

import { Icons } from "../../../data/Assets";

import { getCanadianDollarsString } from "../../../helpers/utility";

import { SVGIcon } from "../../wrappers/SVGIcon";

export const AssessmentsListTable = (props: AssessmentListTableProps) => {
    const { isLoading, assessments, sortQuery, setSortQuery } = props;

    const navigate = useNavigate();

    const columns: IColumnProps[] = [
        { name: "Job Title", sort: true, identifier: 'title', buttonClass: 'btn_block' },
        { name: "NOC Code", sort: true, identifier: 'noc', buttonClass: 'btn_block' },
        { name: "Location", sort: false, identifier: 'location', buttonClass: 'btn_block' },
        { name: "Wage", sort: false, identifier: 'wage', buttonClass: 'btn_block' },
    ];

    const handleSort = (sort_key: EmployerField) => {
        setSortQuery({
            sort_key,
            sort_order: sortQuery.sort_order === 'ASC' ? 'DESC' : 'ASC'
        });
    };

    return (
        <div className="immployer__list_table__container">
            <table className="immployer__list_table">
                <thead>
                    <tr>
                        {columns.map(column =>
                            <th key={column.identifier}>
                                <div>
                                    <button onClick={() => column.sort ? handleSort(column.identifier as EmployerField ?? 'title') : null} className={`${column.buttonClass ?? ''}`}>
                                        {column.name}
                                        {column?.sort && column.identifier === sortQuery.sort_key && <SVGIcon src={Icons.ArrowDownUp} color='primary' />}
                                    </button>
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {!!isLoading &&
                        <tr>
                            <td colSpan={columns.length}>
                                <div className="display_flex flex_dir_column display_flex_center">
                                    <span className="wt_600 pb_10">Loading</span>
                                    <i className='immployer__list_loader' />
                                </div>
                            </td>
                        </tr>
                    }
                    {!isLoading && !assessments?.length &&
                        <tr>
                            <td colSpan={columns.length} className='text_center'>
                                No records found.
                            </td>
                        </tr>
                    }
                    {
                        !isLoading && !!assessments?.length &&
                        assessments.map(assessment =>
                            <tr
                                key={assessment.id}
                                onClick={() => navigate(`/assessments/${assessment.id}/details`)}
                            >
                                <td>{assessment.title}</td>
                                <td>{assessment.noc}</td>
                                <td>{assessment.location.identifier}</td>
                                <td>${getCanadianDollarsString(assessment.wage_min.toString())}-${getCanadianDollarsString(assessment.wage_max.toString())}</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    );
};